import { render, staticRenderFns } from "./docTip.vue?vue&type=template&id=98522d90&"
import script from "./docTip.vue?vue&type=script&lang=js&"
export * from "./docTip.vue?vue&type=script&lang=js&"
import style0 from "./docTip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports